import {
  createContext,
  type ReactNode,
  useContext,
  useMemo,
  useState,
} from 'react'

import type { InvoiceOrEstimate } from '~/types'

import type {
  PaymentRequestDialogContextType,
  PaymentRequestDialogStateType,
} from '../constants/paymentRequestDialogV2Constants'

const PaymentRequestDialogContext =
  createContext<PaymentRequestDialogContextType | null>(null)

export interface PaymentRequestDialogProviderProps {
  children: ReactNode
  invoice: InvoiceOrEstimate
}

export const PaymentRequestDialogProvider = ({
  children,
  invoice,
}: PaymentRequestDialogProviderProps) => {
  const [dialogState, setDialogState] = useState<PaymentRequestDialogStateType>(
    {},
  )

  const actions = useMemo(
    () => ({
      sendPayment: () => {
        // TODO: wire to API when form is ready
      },
    }),
    [],
  )

  const contextValue = useMemo<PaymentRequestDialogContextType>(
    () => ({
      actions,
      dialogState,
      invoice,
    }),
    [actions, dialogState, invoice],
  )

  return (
    <PaymentRequestDialogContext.Provider value={contextValue}>
      {children}
    </PaymentRequestDialogContext.Provider>
  )
}

export const usePaymentRequestDialog = (): PaymentRequestDialogContextType => {
  const context = useContext(PaymentRequestDialogContext)
  if (!context) {
    throw new Error(
      'usePaymentRequestDialog must be used within a PaymentRequestDialogProvider',
    )
  }
  return context
}
